import React, {ReactNode} from 'react';

import * as S from './RunPendingResultsPopup.styles';

type RunPendingResultsPopupProps = {
  children: ReactNode;
  isPendingUpdates: boolean;
};

export const RunPendingResultsPopup = ({
  children,
  isPendingUpdates,
}: RunPendingResultsPopupProps) => (
  <S.RunPendingResultsPopup
    content="The metrics you see in the Runs Table for this run have a 5
      minute delay because of the large size of this run’s summary.
      Click this run to view real-time metrics."
    disabled={!isPendingUpdates}
    on="hover"
    onOpen={() => window.analytics?.track('Run pending updates tooltip viewed')}
    popperModifiers={{
      preventOverflow: {enabled: false},
    }}
    position="top center"
    trigger={children}
  />
);
